import { Form, FormValue } from '@ubud/form';
import { Observable } from 'rxjs/Observable';
import { UI } from '@shared/models/ui';
import { Component, OnInit } from '@angular/core';
import { RegisterUserFormFactory } from '@lemsar/auth/factories/register-user-form.factory';
import { RegisterInstitutionFormFactory } from '@lemsar/auth/factories/register-institution-form.factory';
import {
    RegisterInstitution,
    RegisterInstitutionGovernment,
    RegisterInstitutionIndustrial,
    RegisterInstitutionPrivate,
    RegisterUser,
    RegisterInstitutionCommunity,
} from '@lemsar/auth/domains/models/register';
import { RegisterInstitutionGovernmentFormFactory } from '@lemsar/auth/factories/register-institution-government-form.factory';
import { RegisterInstitutionPrivateFormFactory } from '@lemsar/auth/factories/register-institution-private-form.factory';
import { InstitutionTypeService } from '@lemsar/common/domains/services/institution-type.service';
import { InstitutionType } from '@lemsar/common/domains/models/institution-type';
import { Ministry } from '@lemsar/common/domains/models/ministry';
import { MinistryService } from '@lemsar/common/domains/services/ministry.service';
import { AddressingService } from '@lemsar/common/domains/services/addressing.service';
import { PostalCode } from '@lemsar/common/domains/models/addressing';
import { RegisterService } from '@lemsar/auth/domains/services/register.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyService } from '@lemsar/common/domains/services/company.service';
import { NotificationService } from '@shared/module/notification/services/notification.service';
import { Notification } from '@shared/module/notification/model/notification';
import { Color } from '@shared/enum/ui';
import { AuthStore } from '@lemsar/storage/stores/auth.store';
import { tap } from 'rxjs/operators';
import { RegisterInstitutionIndustrialFormFactory } from '@lemsar/auth/factories/register-institution-industrial-form.factory';
import { RegisterInstitutionCommunityFormFactory } from '@lemsar/auth/factories/register-institution-community-form.factory';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    12/06/2018
 */
@Component({
    selector: 'lemsar-register-container',
    template: `
        <ng-container *ngIf="ui$ | async; let ui">
            <div class="alert alert-danger" *ngIf="ui.error">
                {{ ui.error }}
            </div>

            <!--<lemsar-register-user-form [hidden]="form1" #registerUserForm-->
                                       <!--[form]="userForm"-->
                                       <!--(valueChanges)="readyForSubmitUser = 'VALID' === $event.status"-->
                                       <!--(submitted)="onSubmitUser($event)">-->
            <!--</lemsar-register-user-form>-->

            <lemsar-register-type-component [hasTitle]="true" [selectedType]="registerType" (typeChanges)="selectedRegisterType($event)">
            </lemsar-register-type-component>

            <ng-container *ngIf="registerType != 'landing'">
            <lemsar-register-institution-form [hidden]="form2" #registerInstitutionForm
                                              [form]="institutionForm"
                                              [institutionTypes]="institutionTypes"
                                              [postalCodes]="postalCodes"
                                              [findCompany]="loadingSearchCompany"
                                              [dataTypePrivateInstitution]="dataTypePrivateInstitution"
                                              [registerType]="registerType"
                                              (change)="countChange($event)"
                                              (changeCompanyCode)="searchCompanyCode($event)"
                                              (selectedRegisterType)="selectedRegisterType($event)"
                                              (changePrivateInstitutionType)="changePrivateType($event)"
                                              (valueChanges)="readyForSubmitInstitution = 'VALID' === $event.status"
                                              (submitted)="onSubmitInstitution($event)">
            </lemsar-register-institution-form>

            <lemsar-register-institution-government-form [hidden]="form3A" #registerInstitutionGovernmentForm
                                                         [form]="institutionGovernmentForm"
                                                         [ministries]="ministries"
                                                         (valueChanges)="readyForSubmitInstitutionGovernment = 'VALID' === $event.status"
                                                         (submitted)="onSubmitInstitutionGovernment($event)">
            </lemsar-register-institution-government-form>

            <lemsar-register-institution-private-form [hidden]="form3B" #registerInstitutionPrivateForm
                                                      [form]="institutionPrivateForm"
                                                      (valueChanges)="readyForSubmitInstitutionPrivate = 'VALID' === $event.status"
                                                      (submitted)="onSubmitInstitutionPrivate($event)">
            </lemsar-register-institution-private-form>

                <lemsar-register-institution-private-form [hidden]="form3C" #registerInstitutionIndustrialForm
                                                          [form]="institutionIndustrialForm"
                                                          (valueChanges)="readyForSubmitInstitutionIndustrial = 'VALID' === $event.status"
                                                          (submitted)="onSubmitInstitutionIndustrial($event)">
                </lemsar-register-institution-private-form>

                <lemsar-register-institution-community-form
                    [hidden]="form3D" #registerInstitutionCommunityForm
                    [form]="institutionCommunityForm"
                    (valueChanges)="readyForSubmitInstitutionCommunity = 'VALID' === $event.status"
                    (submitted)="onSubmitInstitutionCommunity($event)">
                </lemsar-register-institution-community-form>

            <p class="small" *ngIf="form3D">
                <span class="text-danger">*</span>)
                Wajib Diisi.
            </p>

            <div class="row mt-4" [hidden]="form1">
                <div class="col">

                </div>
                <div class="col">
                    <!--<button (click)="registerUserForm.submit()"-->
                            <!--[hidden]="form1"-->
                            <!--[disabled]="!readyForSubmitUser || ui.loading"-->
                            <!--class="btn btn-primary btn-pd-lg btn-block text-center">-->
                        <!--Selanjutnya-->
                    <!--</button>-->
                </div>
            </div>

                <div class="row mt-4" [hidden]="form2" style="padding-bottom: 24px">
                <div class="col">
                    <button (click)="selectedRegisterType('landing')"
                            [hidden]="form2"
                            class="btn btn-light btn-pd-lg btn-block text-center">
                        Sebelumnya
                    </button>
                </div>
                <div class="col">
                    <button (click)="registerInstitutionForm.submit()"
                            [hidden]="form2"
                            [disabled]="!readyForSubmitInstitution || ui.loading"
                            class="btn btn-primary btn-pd-lg btn-block text-center">
                        Selanjutnya
                    </button>
                </div>
            </div>

                <div class="row mt-4" [hidden]="form3A" style="padding-bottom: 24px">
                <div class="col">
                    <button (click)="previous()"
                            [hidden]="form3A"
                            [disabled]="ui.loading"
                            class="btn btn-light btn-pd-lg btn-block text-center">
                        Sebelumnya
                    </button>
                </div>
                <div class="col">
                    <button (click)="registerInstitutionGovernmentForm.submit()"
                            [hidden]="form3A"
                            [disabled]="!readyForSubmitInstitutionGovernment || ui.loading"
                            class="btn btn-primary btn-pd-lg btn-block text-center">
                        <ng-container *ngIf="ui.loading; else buttonLabelA">
                            <ubud-loader-component></ubud-loader-component>
                        </ng-container>
                        <ng-template #buttonLabelA>Daftar</ng-template>
                    </button>
                </div>
            </div>

                <div class="row mt-4" [hidden]="form3B" style="padding-bottom: 24px">
                <div class="col">
                    <button (click)="previous()"
                            [hidden]="form3B"
                            [disabled]="ui.loading"
                            class="btn btn-light btn-pd-lg btn-block text-center">
                        Sebelumnya
                    </button>
                </div>
                <div class="col">
                    <button (click)="registerInstitutionPrivateForm.submit()"
                            [hidden]="form3B"
                            [disabled]="!readyForSubmitInstitutionPrivate || ui.loading"
                            class="btn btn-primary btn-pd-lg btn-block text-center">
                        <ng-container *ngIf="ui.loading; else buttonLabelB">
                            <ubud-loader-component></ubud-loader-component>
                        </ng-container>
                        <ng-template #buttonLabelB>Daftar</ng-template>
                    </button>
                </div>
            </div>
                <div class="row mt-4" [hidden]="form3C" style="padding-bottom: 24px">
                    <div class="col">
                        <button (click)="previous()"
                                [hidden]="form3C"
                                [disabled]="ui.loading"
                                class="btn btn-light btn-pd-lg btn-block text-center">
                            Sebelumnya
                        </button>
                    </div>
                    <div class="col">
                        <button (click)="registerInstitutionIndustrialForm.submit()"
                                [hidden]="form3C"
                                [disabled]="!readyForSubmitInstitutionIndustrial || ui.loading"
                                class="btn btn-primary btn-pd-lg btn-block text-center">
                            <ng-container *ngIf="ui.loading; else buttonLabelC">
                                <ubud-loader-component></ubud-loader-component>
                            </ng-container>
                            <ng-template #buttonLabelC>Daftar</ng-template>
                        </button>
                    </div>
                </div>

                <div class="row mt-4" [hidden]="form3D" style="padding-bottom: 24px">
                    <div class="col">
                        <button (click)="previous()"
                                [hidden]="form3D"
                                [disabled]="ui.loading"
                                class="btn btn-light btn-pd-lg btn-block text-center">
                            Sebelumnya
                        </button>
                    </div>
                    <div class="col">
                        <button (click)="registerInstitutionCommunityForm.submit()"
                                [hidden]="form3D"
                                [disabled]="!readyForSubmitInstitutionCommunity || ui.loading"
                                class="btn btn-primary btn-pd-lg btn-block text-center">
                            <ng-container *ngIf="ui.loading; else buttonLabelC">
                                <ubud-loader-component></ubud-loader-component>
                            </ng-container>
                            <ng-template #buttonLabelC>Daftar</ng-template>
                        </button>
                    </div>
                </div>
            </ng-container>

        </ng-container>
    `,
    providers: [
        RegisterUserFormFactory,
        RegisterInstitutionFormFactory,
        RegisterInstitutionGovernmentFormFactory,
        RegisterInstitutionPrivateFormFactory,
        RegisterInstitutionIndustrialFormFactory,
        RegisterInstitutionCommunityFormFactory,
    ],
})
export class RegisterContainer implements OnInit {
    public userForm: Form;
    public institutionForm: Form;
    public institutionGovernmentForm: Form;
    public institutionPrivateForm: Form;
    public institutionIndustrialForm: Form;
    public institutionCommunityForm: Form;
    public readyForSubmitUser: boolean = false;
    public readyForSubmitInstitution: boolean = false;
    public readyForSubmitInstitutionGovernment: boolean = false;
    public readyForSubmitInstitutionPrivate: boolean = false;
    public readyForSubmitInstitutionIndustrial: boolean = false;
    public readyForSubmitInstitutionCommunity: boolean = false;
    public ui$: Observable<UI>;
    public ui: UI;

    public start: number = 2;
    public end: number = 3;

    public step: number = 2;

    public form1: boolean = true;
    public form2: boolean = false;
    public form3A: boolean = true;
    public form3B: boolean = true;
    public form3C: boolean = true;
    public form3D: boolean = true;

    public institutionType: string | null = null;
    public registerType: string | null = null;
    public findCodeCompany: boolean;
    public loadingSearchCompany: boolean = true;
    public companyCode: string;

    public institutionTypes: Array<InstitutionType> = [];
    public ministries: Array<Ministry> = [];
    public postalCodes: Array<PostalCode> = [];
    public dataTypePrivateInstitution: { id: number; name: string }[];

    private userRequestForm: RegisterUser;
    private institutionRequestForm: RegisterInstitution;
    private institutionGovernmentRequestForm: RegisterInstitutionGovernment;
    private institutionPrivateRequestForm: RegisterInstitutionPrivate;
    private institutionIndustrialRequestForm: RegisterInstitutionIndustrial;
    private institutionCommunityRequestForm: RegisterInstitutionCommunity;

    public constructor(
        private registerService: RegisterService,
        private companyService: CompanyService,
        private notificationService: NotificationService,
        private formUserFactory: RegisterUserFormFactory,
        private formInstitutionFactory: RegisterInstitutionFormFactory,
        private formInstitutionGovernmentFactory: RegisterInstitutionGovernmentFormFactory,
        private formInstitutionPrivateFactory: RegisterInstitutionPrivateFormFactory,
        private formInstitutionIndustrialFactory: RegisterInstitutionIndustrialFormFactory,
        private formInstitutionCommunityFactory: RegisterInstitutionCommunityFormFactory,
        private institutionTypeService: InstitutionTypeService,
        private ministryService: MinistryService,
        private addressingService: AddressingService,
        private router: Router,
        private route: ActivatedRoute,
        private auth: AuthStore,
    ) {
        this.userForm = this.formUserFactory.create();
        this.institutionForm = this.formInstitutionFactory.create();
        this.institutionGovernmentForm = this.formInstitutionGovernmentFactory.create();
        this.institutionPrivateForm = this.formInstitutionPrivateFactory.create();
        this.institutionIndustrialForm = this.formInstitutionIndustrialFactory.create();
        this.institutionCommunityForm = this.formInstitutionCommunityFactory.create();
        this.ui$ = this.registerService.ui$;
        this.ui = this.registerService.ui;
    }

    public ngOnInit(): void {
        // this.loadInstitutionTypes('government');
        // this.loadMinistries();
        // this.dataTypePrivateInstitution = [{ id: 10, name: 'Mandiri' }, { id: 20, name: 'Industri' }];

        this.subscribeParams().subscribe();
    }

    public subscribeParams() {
        return this.route.params.pipe(tap(param => this.selectedRegisterType(param.type)));
    }

    public onSubmitUser(user: FormValue<RegisterUser>): void {
        if ('VALID' === user.status) {
            this.userRequestForm = user.data;
        }

        this.next();
    }

    public onSubmitInstitution(institution: FormValue<RegisterInstitution>): void {
        if ('VALID' === institution.status) {
            this.institutionRequestForm = institution.data;
        }

        this.institutionType = institution.data.register_type;
        this.next();
    }

    public onSubmitInstitutionGovernment(value: FormValue<RegisterInstitutionGovernment>): void {
        if ('VALID' === value.status) {
            this.institutionGovernmentRequestForm = value.data;

            const data = Object.assign(this.institutionRequestForm, this.institutionGovernmentRequestForm);

            this.registerService.registerGovernment(data).subscribe(
                (response: any) => {
                    this.auth.refreshUser().then(() => {
                        this.router.navigateByUrl('/institutions/' + response.institution.id + '/wizard');
                    });
                },
                (error: any) => {
                    this.ui.loading = false;
                },
            );
        }
    }

    public onSubmitInstitutionPrivate(value: FormValue<RegisterInstitutionPrivate>): void {
        if ('VALID' === value.status) {
            this.institutionPrivateRequestForm = value.data;

            const data = Object.assign(this.institutionRequestForm, this.institutionPrivateRequestForm);

            this.registerService.registerPrivate(data).subscribe(
                (response: any) => {
                    this.auth.refreshUser().then(() => {
                        this.router.navigateByUrl('/institutions/' + response.institution.id + '/wizard');
                    });
                },
                (error: any) => {
                    this.ui.loading = false;
                },
            );
        }
    }

    public onSubmitInstitutionIndustrial(value: FormValue<RegisterInstitutionIndustrial>): void {
        if ('VALID' === value.status) {
            this.institutionIndustrialRequestForm = value.data;

            const data = Object.assign(this.institutionRequestForm, this.institutionIndustrialRequestForm);

            this.registerService.registerIndustrial(data).subscribe(
                (response: any) => {
                    this.auth.refreshUser().then(() => {
                        this.router.navigateByUrl('/institutions/' + response.institution.id + '/wizard');
                    });
                },
                (error: any) => {
                    this.ui.loading = false;
                },
            );
        }
    }

    public onSubmitInstitutionCommunity(value: FormValue<RegisterInstitutionCommunity>): void {
        if ('VALID' === value.status) {
            this.institutionCommunityRequestForm = value.data;

            const data = Object.assign(this.institutionRequestForm, this.institutionCommunityRequestForm);

            this.registerService.registerCommunity(data).subscribe(
                (response: any) => {
                    this.auth.refreshUser().then(() => {
                        this.router.navigateByUrl('/institutions/' + response.institution.id + '/wizard');
                    });
                },
                (error: any) => {
                    this.ui.loading = false;
                },
            );
        }
    }

    public previous(): void {
        if (this.start < this.step) {
            this.step = this.step - 1;
        }

        window.scroll(0, 0);
        this.loadForm();
    }

    public next(): void {
        if (this.end > this.step) {
            this.step = this.step + 1;
        }

        window.scroll(0, 0);
        this.loadForm();
    }

    public loadForm(): void {
        if (1 === this.step) {
            this.form1 = false;
            this.form2 = true;
            this.form3A = true;
            this.form3B = true;
            this.form3C = true;
            this.form3D = true;
        }

        if (2 === this.step) {
            this.form1 = true;
            this.form2 = false;
            this.form3A = true;
            this.form3B = true;
            this.form3C = true;
            this.form3D = true;
        }

        if (3 === this.step) {
            if ('government' === this.institutionType) {
                this.form1 = true;
                this.form2 = true;
                this.form3A = false;
                this.form3B = true;
                this.form3C = true;
                this.form3D = true;
            }

            if ('private' === this.institutionType) {
                this.form1 = true;
                this.form2 = true;
                this.form3A = true;
                this.form3B = false;
                this.form3C = true;
                this.form3D = true;
            }

            if ('industrial' === this.institutionType) {
                this.form1 = true;
                this.form2 = true;
                this.form3A = true;
                this.form3B = true;
                this.form3C = false;
                this.form3D = true;
            }

            if ('community' === this.institutionType) {
                this.form1 = true;
                this.form2 = true;
                this.form3A = true;
                this.form3B = true;
                this.form3C = true;
                this.form3D = false;
            }
        }
    }

    public countChange(event: any): void {
        if (event.length >= 3) {
            this.loadPostalCodes(event);
        }
    }

    public loadPostalCodeById(id: string, data: any): void {
        this.addressingService.fetchPostalCodeById(id).subscribe((response: PostalCode) => {
            this.postalCodes.push(response);
            this.setCompanyData(data);
        });
    }

    public searchCompanyCode(event: any): void {
        this.companyCode = event;
        this.loadingSearchCompany = false;
        this.companyService.fetchCompanyByCode(this.companyCode).subscribe((data: any) => {
            if (0 === data.length) {
                this.findCodeCompany = false;
                this.institutionForm.formGroup.disable();
                this.notificationService.add(
                    new Notification({
                        color: Color.Danger,
                        message: 'Data perusahaan tidak ditemukan',
                    }),
                );
            } else {
                this.findCodeCompany = true;
                this.loadPostalCodeById(data.postalCodeId, data);
                this.institutionForm.formGroup.enable();
                this.institutionIndustrialForm.formGroup.patchValue({
                    license_number: data.companyable.businessLicense,
                    tax_number: data.tax,
                });
                this.institutionIndustrialForm.formGroup.enable();
            }

            this.loadingSearchCompany = true;
        });
    }

    private setCompanyData(data: any): void {
        this.institutionForm.formGroup.patchValue({
            wlkp_code: this.companyCode,
            institution_name: data.name,
            owner: data.ownerName,
            postal_code: data.postalCodeId,
            address: data.address,
            phone: data.phone,
            institution_email: data.email.toLowerCase(),
            website: data.website,
        });
    }

    public selectedRegisterType(event: any): void {
        this.registerType = event;
        this.institutionForm.formGroup.reset();

        this.router.navigate(['/auth/register', this.registerType]);

        if ('landing' === this.registerType) {
            return;
        }

        if ('government' === this.registerType) {
            this.institutionForm.formGroup.enable();
            this.loadInstitutionTypes('government');
            this.loadMinistries();
        } else if ('private' === this.registerType) {
            this.institutionForm.formGroup.enable();
            // this.institutionForm.formGroup.get('private_type')!.enable();
            this.loadInstitutionTypes('private');
        } else if ('industrial' === this.registerType) {
            this.institutionForm.formGroup.disable();
            this.institutionPrivateForm.formGroup.disable();
            this.institutionForm.formGroup.get('wlkp_code')!.enable();
        } else if ('community' === this.registerType) {
            this.institutionForm.formGroup.enable();
            this.institutionCommunityForm.formGroup.enable();
            this.loadInstitutionTypes('community');
            this.readyForSubmitInstitutionCommunity = true;
        }
    }

    public loadInstitutionTypes(type?: string): void {
        if (type === 'private') {
            type += '&exclude[]=BLK KOMUNITAS';
        }
        this.institutionTypeService.fetchAll(type).subscribe((data: Array<InstitutionType>) => {
            if (type === 'community') {
                this.institutionTypes = data.filter(tp => tp.name === 'BLK KOMUNITAS');
                const typeControl = this.institutionForm.formGroup.controls.institution_type;
                typeControl.setValue(this.institutionTypes[0]);
            } else {
                this.institutionTypes = data;
            }
        });
    }

    public loadMinistries(): void {
        this.ministryService.fetchAll().subscribe((data: Array<Ministry>) => {
            this.ministries = data;
        });
    }

    public loadPostalCodes(key: string): void {
        this.addressingService.fetchAllPostalCodes(key).subscribe((data: Array<PostalCode>) => {
            this.postalCodes = data;
        });
    }

    public changePrivateType(event: any): void {
        this.institutionForm.formGroup.enable();
        this.institutionPrivateForm.formGroup.enable();

        if (20 === event) {
            this.institutionForm.formGroup.disable();
            this.institutionPrivateForm.formGroup.disable();
            this.institutionForm.formGroup.get('private_type')!.enable();
            this.institutionForm.formGroup.get('wlkp_code')!.enable();
        }
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/views/containers/register.container.ts